<div class="flex flex-col items-center justify-center gap-6 py-32 mb-32 w-10/12 max-w-2xl h-screen mx-auto text-center">
	<h1 class="uppercase text-3xl md:text-5xl font-dinpro-bold">{{ 'page.marketplace.maintenance.heading' | translate }}</h1>
	<p class="text-peps-dark-200/60 text-sm font-notosans md:text-base max-w-md">{{ 'page.marketplace.maintenance.text' | translate }}</p>
	<a
		routerLink="/collection/shop"
		class="mt-4 inline-flex items-center gap-2 border border-peps-gold/40 text-peps-gold hover:bg-peps-gold/10 rounded-md px-5 py-2 text-sm uppercase tracking-wider transition-colors">
		{{ 'page.marketplace.maintenance.back' | translate }}
	</a>
</div>
